import React from 'react';
import styles from './ItemsSection.module.scss';
import { Button, Icon } from 'components/common';
import { icons } from 'assets';
import Item from './Item';
import { ItemsSectionProps } from './types';

const ItemsSection = (props: ItemsSectionProps) => {
  const {
    items = [],
    label = 'Label',
    scrollTop = 0
  } = props;

  const [expand, setExpand] = React.useState(false);

  return (
    <div className={styles.container}>
      <Button
        className={styles.labelButton}
        onClick={() => setExpand(!expand)}
      >
        <span>{label} ({items.length})</span>
        <Icon icon={expand ? icons.arrowDown : icons.arrowRight} />
      </Button>
      {expand &&
        items.map((item, index) =>
          <Item
            key={index}
            item={item}
            scrollTop={scrollTop}
          />
        )}
    </div>
  );
};

export default ItemsSection;
